module.exports = __webpack_public_path__ + "static/media/oboe.b8054a37.wav";